import { handHeart_dark, handHeart_white, finance_dark, finance_white, flower_dark, flower_white } from  "../../../../assets";


const infoItems = [
    {
        logoDark: handHeart_dark,
        logoWhite: handHeart_white,
        title: 'Flexible Financing Options',
        description: 'We offer a range of services to help businesses secure the funding they need to thrive.',
        redirectLink: 'Learn More'
    },
    {
        logoDark: finance_dark,
        logoWhite: finance_white,
        title: 'Unlock the Potential of Your Business',
        description: 'Our team of experts will guide you through the funding process, ensuring a smooth experience.',
        redirectLink: 'Learn More'
    },
    {
        logoDark: flower_dark,
        logoWhite: flower_white,
        title: 'Accelerate Your Business Growth',
        description: 'We provide customized funding options to meet the unique needs of your business.',
        redirectLink: 'Learn More'
    }
];

export default infoItems;